import { EventsManager } from '@game-libs/events-manager';
import { useGameDispatch } from '../global-context';
import { useGameStatusStore } from '../zustand/useGameStatusStore';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { QuickGameDialog } from '@game-libs/quick-game-dialog';
import { CONFIG } from '../../config';
import { GameplayEvents } from '../../types/game-events';
import { GUIActions } from '../../types/game-types';

// const placedholderWatcher = new ThresholdWatcher(
//   [{ threshold: CONFIG.game.initialDragonHealth * 0.499999, wasTriggered: false }],
//   'down',
//   false,
// );

export const useCheckAfterTick = () => {
  const dispatch = useGameDispatch();
  const stunEffectTickDurationRemaining = useGameStatusStore((s) => s.stunEffectTickDurationRemaining);
  const { i18n } = useTranslation();

  const { emit, once } = EventsManager();

  useEffect(() => {
    if (stunEffectTickDurationRemaining <= 0) {
      emit(GameplayEvents.UNSTUN_UNITS);
    }
  }, [stunEffectTickDurationRemaining]);

  // Narrative watcher listeners
  useEffect(() => {

    const { openDialog } = QuickGameDialog({
      pathToInkFiles: './dialogs',
      pathToSpeakerFiles: './dialogs/pictures',
      containerId: 'ui-wrapper',
    });

    const unsub5 = once('met_dragon', () => {
      setTimeout(() => {
        dispatch({
          type: GUIActions.MET_DRAGON,
        });
      }, 1000);
    });

    const unsub6 = once(GameplayEvents.WAIT_FOR_LAST_HIT, () => {
      if (!CONFIG.game.skipDialogs) {
        setTimeout(() => {
          openDialog('coup_de_grace', i18n.language);
        }, 0);
      }
    });

    return () => {
      unsub5?.();
      unsub6?.();
    };
  }, []);
};
